import React from 'react';

import Icon from './Icon';

const icons = {
  website: {
    type: 'fal',
    icon: 'browser'
  },
  blog: {
    type: 'fal',
    icon: 'blog'
  },
  email: {
    type: 'fal',
    icon: 'at'
  }
};

class ChannelIcon extends React.Component {
  render() {
    const { channel, ...props } = this.props;

    let iconProps = {};

    if (icons.hasOwnProperty(channel.type)) {
      iconProps = icons[channel.type];
    } else {
      iconProps = {
        type: 'brand',
        icon: channel.type
      };
    }

    return <Icon fixedWidth {...iconProps} {...props} />;
  }
}

export default ChannelIcon;



// WEBPACK FOOTER //
// ./src/components/ui/ChannelIcon.js